/*
 * hy.frontend.core
 *
 * NOTE: this file is not subject to copyright transfer
 * UWAGA: plik nie objęty przekazaniem praw autorskich
 * © 2016 Hycom S.A.
 *
 */


define(['t3', 'hy/hy-service', 'hy/hy-utils', 'lodash', 'core/events/event-list', 'jquery', 'lib/velocity/velocity'], function(T3, BaseService, hyutils, lodash, EVENTS, $, Velocity) {

    'use strict';

    return BaseService.addService('expander', function(application) {
        var options = {
            triggerSelector: '.js-expander__trigger', // selector triggering expanding/collapsing
            contentSelector: '.js-expander__content', // expanding/collapsing content selector
            parentClass: 'js-expander__container', // parent class for both trigger and content
            nextSelector: '.js-expander__next', // selector triggering a next section
            prevSelector: '.js-expander__prev', // selector triggering a previous section
            expandedClass: 'is-expanded', // class added for expanded containers
            isExpandingClass: 'is-expanding', // class added for expanding time
            isCollapsingClass: 'is-collapsing', // class added for collapsing time
            duration: 500, // animation duration
            easing: 'Quad', // animation easing type (concatenated with in/out/inOut)
            hideOtherElements: false, // false - all items open and close independently, true - all items will be collapsed before opening the selected element
            targetForHash: 'a',
            addDataHashToUrl: false, // if true when section is opened data-hash value will be added to browser url
            radioLabel: false,
            scrollToSelected: true, // if false auto scroll to selected element will be disabled
            scrollTohash: false, // if true scroll to selected element will be procesed
            mobileExpander: '', // if hide in mobile, expanded content will wee hidden on module load or window resize;

            //use switch to show hide content in expander
            switchTrigger: false,
            switchTriggerVal: [
                'open',
                'close'
            ]
        };

        function Expander(_module, _options) {

            var events = [],
                triggers = [],
                prevs = [],
                nexts = [],
                currentSection,
                urlRedirect = window.location.hash.substr(1),
                started;

            //var htmlAndBody = $('html, body');

            function loadByHash(hash) {
                // TODO verify use case of urlRedirect, especially on change
                if (isAnimating() || (!hash && !urlRedirect)) return;

                if (hash)
                    urlRedirect = hash;

                var $trigger = _module.find(_options.targetForHash + '[data-hash="' + urlRedirect + '"]').first();
                var $section = getSectionByTrigger($trigger);

                if (notFound($section)) return;

                // Needed, by the time we enter the callback, all sections are collapsed
                var isExpanded = isSectionExpanded($section);

                collapseAllSection($trigger[0].id, function() {
                    if (!isExpanded)
                        openSelection($trigger[0].id, _options.scrollTohash === true);
                });
            }

            function trigerBySwitch(trigger) {
                var $trigger = $(trigger);
                if (_options.switchTriggerVal[0] === $trigger.val()) {
                    openSelection($trigger.attr('id'), false);
                } else if (_options.switchTriggerVal[1] === $trigger.val()) {
                    collapseCurrentSection($trigger.attr('id'));
                }
            }

            function addDataHashToUrl(target) {
                var $targetElement = $(document.getElementById(target));
                var attr = $targetElement.attr('data-hash');
                if (typeof attr !== typeof undefined && attr !== false) {
                    document.location.hash = attr;
                }
            }

            function openSelection(target, state) {
                var $targetElement = $(document.getElementById(target));

                _options.addDataHashToUrl ? addDataHashToUrl(target) : null;

                currentSection = $targetElement.parents('.' + _options.parentClass).first();
                // broadcast an event indicating start of an animation
                //application.broadcast(EVENTS.modules.expander.animation.started, state, _module[0].id);
                animationStarted(state);


                //_module.find('.' + _options.parentClass).removeClass(_options.expandedClass);
                expandSection(currentSection, function($section) {
                    $section.addClass(_options.expandedClass);
                    showWholeSection($section);
                });

            }

            function openDirectSelection(triggerId) {
                var $section = getSectionByTriggerId(triggerId);

                if (notFound($section) ||
                    isSectionExpanded($section) ||
                    isSectionExpanding($section)) return;

                if (_options.hideOtherElements) {
                    collapseAllSection(triggerId, function() {
                        openSelection(triggerId);
                    });
                } else {
                    openSelection(triggerId);
                }
            }

            function collapseDirectSelection(triggerId) {
                var $section = getSectionByTriggerId(triggerId);

                if (notFound($section) ||
                    isSectionCollapsed($section) ||
                    isSectionCollapsing($section)) return;

                animationStarted();

                collapseSection(currentSection, function($section) {
                    $section.removeClass(_options.expandedClass);
                    animationEnded($section);
                });
            }

            function toggleSection(target) {
                currentSection = $(document.getElementById(target)).parents('.' + _options.parentClass).first();

                // broadcast an event indicating start of an animation
                //application.broadcast(EVENTS.modules.expander.animation.started, null, _module[0].id);
                animationStarted(null);

                if (_options.hideOtherElements) {

                    // if triggered section is already open, just collapse it
                    if (currentSection.hasClass(_options.expandedClass)) {
                        collapseSection(currentSection, function($section) {
                            $section.removeClass(_options.expandedClass);
                            //application.broadcast(EVENTS.modules.expander.animation.ended, currentSection, _module[0].id);
                            animationEnded($section);
                        });
                        // else, expand triggered section and collapse all others
                    } else {
                        var openElements = _module.find('.' + _options.parentClass + '.' + _options.expandedClass);

                        // if any section is already open
                        if (openElements.length) {
                            // collapse all open sections
                            collapseSection(openElements, function() {
                                // after animation finishes, expand triggered section
                                _module.find('.' + _options.parentClass).removeClass(_options.expandedClass);
                                expandSection(currentSection, function($section) {
                                    $section.addClass(_options.expandedClass);
                                    showWholeSection($section);
                                });
                            });
                            // else just open triggered section
                        } else {
                            _module.find('.' + _options.parentClass).removeClass(_options.expandedClass);
                            expandSection(currentSection, function($section) {
                                $section.addClass(_options.expandedClass);
                                showWholeSection($section);
                            });
                        }

                    }
                } else {


                    // if triggered section is already open, just collapse it
                    if (currentSection.hasClass(_options.expandedClass)) {

                        collapseSection(currentSection, function($section) {
                            $section.removeClass(_options.expandedClass);
                            //application.broadcast(EVENTS.modules.expander.animation.ended, currentSection, _module[0].id);
                            animationEnded($section);
                        });
                        // else, expand triggered section
                    } else {
                        // just open triggered section
                        expandSection(currentSection, function($section) {
                            $section.addClass(_options.expandedClass);
                            showWholeSection($section);
                        });
                    }
                }

            }

            function nextSection() {
                //alert(currentSection);
                var sections = _module.find('.' + _options.parentClass);
                var currentIndex = sections.index(currentSection);

                if (currentSection && currentIndex < sections.length - 1) {
                    var next = $(sections[currentIndex + 1]);

                    // collapse all open sections
                    collapseSection(currentSection, function() {
                        _module.find('.' + _options.parentClass).removeClass(_options.expandedClass);

                        // after animation finishes, expand triggered section
                        expandSection(next, function($section) {
                            $section.addClass(_options.expandedClass);
                            showWholeSection($section);
                        });
                    });

                    currentSection = next;

                    // broadcast an event indicating start of an animation
                    //application.broadcast(EVENTS.modules.expander.animation.started, null, _module[0].id);
                    animationStarted(null);
                }
            }

            function prevSection() {
                var sections = _module.find('.' + _options.parentClass);
                var currentIndex = sections.index(currentSection);

                if (currentSection && currentIndex > 0) {
                    var prev = $(sections[currentIndex - 1]);

                    // collapse all open sections
                    collapseSection(currentSection, function() {
                        _module.find('.' + _options.parentClass).removeClass(_options.expandedClass);

                        // after animation finishes, expand triggered section
                        expandSection(prev, function($section) {
                            $section.addClass(_options.expandedClass);
                            showWholeSection($section);
                        });
                    });

                    currentSection = prev;

                    animationStarted(null);
                }
            }

            function expandAllSection(triggerId) {
                var $sections;

                if (triggerId) {
                    $sections = getSectionsByTriggerId(triggerId, 'expand');
                } else {
                    $sections = getSections('expand');
                }

                if (notFound($sections)) {
                    return false;
                }

                $.each($sections, function(i, section) {
                    var $section = $(section);

                    rotateClassOverAnimation($section, true, true);

                    Velocity(getContentBySection($section), "slideDown", {
                        duration: _options.duration,
                        easing: 'easeInOut' + _options.easing,
                        complete: function() {
                            showWholeSection($section);
                            $section.addClass(_options.expandedClass);
                            rotateClassOverAnimation($section, true, false);

                            // broadcast an event indicating expand of an section
                            application.broadcast(EVENTS.modules.expander.expanded, $section[0], _module[0].id, _module[0].id);

                            //console.log('staje się widoczny');
                            var evt = document.createEvent('Event');
                            evt.initEvent('elementbecamevisible', true, true);
                            document.dispatchEvent(evt);
                        }
                    });

                    $section.find(_options.triggerSelector).not(_options.contentSelector).attr('aria-expanded', true);
                    $section.find(_options.contentSelector).first().attr('aria-hidden', false);
                });
            }

            function collapseSection(element, complete) {
                rotateClassOverAnimation(element, false, true);

                Velocity(element.children(_options.contentSelector).first(), "slideUp", {
                    duration: _options.duration,
                    easing: 'easeInOut' + _options.easing,
                    complete: function() {
                        complete(element);
                        rotateClassOverAnimation(element, false, false);

                        application.broadcast(EVENTS.modules.expander.collapsed, element[0], _module[0].id, _module[0].id);

                        console.log('ukrywam się');
                        var evt = document.createEvent('Event');
                        evt.initEvent('elementbecamevisible', false, false);
                        document.dispatchEvent(evt);
                    }
                });

                element.find(_options.triggerSelector).not(_options.contentSelector).attr('aria-expanded', false);
                element.find(_options.contentSelector).first().attr('aria-hidden', true);
            }

            function collapseAllSection(triggerId, complete) {
                var $sections = $();

                if (triggerId) {
                    $sections = getSectionsByTriggerId(triggerId, 'collapse');
                } else {
                    $sections = getSections('collapse');
                }

                if (notFound($sections)) {
                    complete();
                    return;
                }

                $.each($sections, function(i, section) {
                    var $section = $(section);

                    rotateClassOverAnimation($section, false, true);

                    Velocity(getContentBySection($section), "slideUp", {
                        duration: _options.duration,
                        easing: 'easeInOut' + _options.easing,
                        complete: function() {
                            rotateClassOverAnimation($section, false, false);
                            $section.removeClass(_options.expandedClass);
                            application.broadcast(EVENTS.modules.expander.collapsed, $section[0], _module[0].id, _module[0].id);

                            if (i === $sections.length - 1)
                                complete();
                        }
                    });

                    $section.find(_options.triggerSelector).not(_options.contentSelector).attr('aria-expanded', false);
                    $section.find(_options.contentSelector).first().attr('aria-hidden', true);
                });
            }

            function collapseCurrentSection(target) {
                var $target = $(document.getElementById(target));
                var $section = $target.parents('.' + _options.parentClass).first();

                rotateClassOverAnimation($section, false, true);

                Velocity($section.find(_options.contentSelector).first(), "slideUp", {
                    duration: _options.duration,
                    easing: 'easeInOut' + _options.easing,
                    complete: function() {
                        application.broadcast(EVENTS.modules.expander.collapsed, $section[0], _module[0].id, _module[0].id);
                        animationEnded($section);
                        $section.removeClass(_options.expandedClass);

                        rotateClassOverAnimation($section, false, false);

                    }
                });
                $section.find(_options.triggerSelector).not(_options.contentSelector).attr('aria-expanded', false);
                $section.find(_options.contentSelector).first().attr('aria-hidden', true);

            }

            function expandSection(element, complete) {
                rotateClassOverAnimation(element, true, true);
                Velocity(element.children(_options.contentSelector).first(), "slideDown", {
                    duration: _options.duration,
                    easing: 'easeInOut' + _options.easing,
                    complete: function() {
                        complete(element);
                        rotateClassOverAnimation(element, true, false);

                        // broadcast an event indicating expand of an section
                        application.broadcast(EVENTS.modules.expander.expanded, element[0], _module[0].id, _module[0].id);

                        _options.addDataHashToUrl ? addDataHashToUrl(element.find(_options.targetForHash).filter("[data-hash]").first().attr('id')) : null;

                        //console.log('staje się widoczny');
                        var evt = document.createEvent('Event');
                        evt.initEvent('elementbecamevisible', true, true);
                        document.dispatchEvent(evt);
                    }
                });

                element.find(_options.triggerSelector).not(_options.contentSelector).attr('aria-expanded', true);
                element.find(_options.contentSelector).first().attr('aria-hidden', false);
            }

            function showWholeSection(element) {

                animationEnded(element);

                var sections = _module.find('.' + _options.parentClass);
                var currentIndex = sections.index(currentSection);

                application.broadcast(EVENTS.modules.expander.complete, currentIndex, _module[0].id, _module[0].id);
                // }

            }

            function rotateClassOverAnimation(ob, state, event) {
                /*
                 * state true expanding     ||      false collapsing
                 * event true adding class   ||     false remove class
                 */
                if (state) {
                    if (event) {
                        ob.addClass(_options.isExpandingClass);
                    } else {
                        ob.removeClass(_options.isExpandingClass);
                    }
                } else {
                    if (event) {
                        ob.addClass(_options.isCollapsingClass);
                    } else {
                        ob.removeClass(_options.isCollapsingClass);
                    }
                }

            }

            function initAria() {
                var id = _module.attr('id') + '-';
                var counter = 0;

                _module.attr('role', 'tablist');
                _module.attr('aria-multiselectable', 'false');

                var tabs = _module.find('.' + _options.parentClass);

                lodash.forEach(tabs, function(el) {
                    var element = $(el);

                    var trigger = element.find(_options.triggerSelector);
                    var triggerId = trigger.attr('id');
                    trigger.attr('id', triggerId ? triggerId : id + 'control-' + counter);
                    trigger.attr('role', 'tab');

                    var content = element.children(_options.contentSelector).first();
                    var contentId = content.attr('id');
                    content.attr('id', contentId ? contentId : id + 'tab-' + counter);
                    content.attr('role', 'tabpanel');

                    content.attr('aria-labelledby', trigger.attr('id'));
                    trigger.attr('aria-controls', content.attr('id'));

                    trigger.attr('aria-expanded', element.hasClass(_options.expandedClass) ? true : false);
                    content.attr('aria-hidden', element.hasClass(_options.expandedClass) ? false : true);

                    content.removeAttr('aria-expanded');

                    counter++;
                });

            }

            function clearAria() {

                var tabs = _module.find('.' + _options.parentClass);

                lodash.forEach(tabs, function(el) {
                    var element = $(el);
                    var trigger = element.find(_options.triggerSelector);
                    var content = element.children(_options.contentSelector).first();
                    trigger.removeAttr('role');
                    trigger.removeAttr('aria-labelledby');
                    trigger.removeAttr('aria-controls');
                    trigger.removeAttr('aria-expanded');
                    content.removeAttr('aria-labelledby');
                });
            }

            function clearListeners() {
                lodash.forEach(events, function(event) {
                    triggers.off(event, handleToggle);
                    nexts.off(event, handleNext);
                    prevs.off(event, handlePrev);
                });
            }

            function notFound($obj) {
                return $obj.length === 0;
            }

            function getTriggerById(triggerId) {
                return $(document.getElementById(triggerId));
            }

            function getSectionByTriggerId(triggerId) {
                return getSectionByTrigger(
                    getTriggerById(triggerId)
                );
            }

            function getSectionByTrigger($trigger) {
                if (notFound($trigger))
                    return $();

                return $trigger.parents('.' + _options.parentClass).first();
            }

            function getSectionsByTriggerId(triggerId, targetAction, greedy) {
                return getSectionsByTrigger(
                    getTriggerById(triggerId),
                    targetAction,
                    greedy
                );
            }

            function getSectionsByTrigger($trigger, targetAction, greedy) {
                // TODO refactor?
                var sectionSelector = '.' + _options.parentClass;

                var sectionActions = {
                    'collapse': '.' + _options.expandedClass +
                        ':not(.' + _options.isCollapsingClass + ')',
                    'expand': ':not(.' + _options.expandedClass + ')' +
                        ':not(.' + _options.isExpandingClass + ')'
                };

                if (sectionActions[targetAction])
                    sectionSelector += sectionActions[targetAction];

                var $sections = $();

                if (!notFound($trigger)) {
                    var $section = getSectionByTrigger($trigger);

                    if (!notFound($section))
                        $sections = $section
                        .parent()
                        .find(sectionSelector);
                } else if (greedy === true) {
                    $sections = _module.find(sectionSelector);
                }

                return $sections;
            }

            function getSections(targetAction) {
                return getSectionsByTrigger($(), targetAction, true);
            }

            function getContentBySection($section) {
                return $section.children(_options.contentSelector).first();
            }

            function isSectionCollapsed($section) {
                return $section.hasClass(_options.expandedClass) === false;
            }

            function isSectionCollapsing($section) {
                return $section.hasClass(_options.isCollapsingClass);
            }

            function isSectionExpanded($section) {
                return $section.hasClass(_options.expandedClass);
            }

            function isSectionExpanding($section) {
                return $section.hasClass(_options.isExpandingClass);
            }

            function isAnimating() {
                return started === true;
            }

            function animationStarted(state) {
                application.broadcast(EVENTS.modules.expander.animation.started, state, _module[0].id);
                started = true;
            }

            function animationEnded(currentSection) {
                application.broadcast(EVENTS.modules.expander.animation.ended, currentSection, _module[0].id);
                application.broadcast(EVENTS.modules.header.recalculateMenu);
                started = false;
            }

            function handleToggle(event) {
                event.preventDefault();
                if (!_options.radioLabel) {
                    event.preventDefault();
                }
                if (_options.switchTrigger) {
                    application.broadcast(EVENTS.modules.expander.triggered, null, _module[0].id);
                    trigerBySwitch(event.target);
                } else {
                    if (!started) {
                        application.broadcast(EVENTS.modules.expander.triggered, null, _module[0].id);
                        toggleSection(event.currentTarget.id);
                    }
                }
            }

            function handleNext(event) {
                event.preventDefault();
                if (!started) {
                    application.broadcast(EVENTS.modules.expander.triggered, null, _module[0].id);
                    nextSection();
                }
            }

            function handlePrev(event) {
                event.preventDefault();
                if (!started) {
                    application.broadcast(EVENTS.modules.expander.triggered, null, _module[0].id);
                    prevSection();
                }
            }


            return {
                init: function(_events) {
                    events = _events;
                    triggers = _module.find(_options.triggerSelector);
                    nexts = _module.find(_options.nextSelector);
                    prevs = _module.find(_options.prevSelector);
                    started = false;


                    var initSection = _module.find('.' + _options.parentClass + '.' + _options.expandedClass);


                    if (initSection.length > 0) {
                        currentSection = initSection.eq(0);
                    }

                    initAria();
                    loadByHash();

                    lodash.forEach(events, function(event) {
                        triggers.on(event, handleToggle);
                        nexts.on(event, handleNext);
                        prevs.on(event, handlePrev);
                    });

                },

                destroy: function() {
                    lodash.forEach(events, function(event) {
                        // parents.off(event, triggers, handleToggle);
                        triggers.off(event, handleToggle);
                        nexts.off(event, handleNext);
                        prevs.off(event, handlePrev);
                    });
                    lodash.forEach(_module.find(_options.contentSelector), function(content) {
                        $(content).attr('style', '');
                    });
                },

                getOptions: function() {
                    return _options;
                },

                getCurrentSection: function() {
                    return currentSection;
                },

                reloadmMdule: function() {
                    clearAria();
                    clearListeners();
                    initAria();
                    loadByHash();

                    triggers = _module.find(_options.triggerSelector);
                    lodash.forEach(events, function(event) {
                        triggers.on(event, handleToggle);
                        nexts.on(event, handleNext);
                        prevs.on(event, handlePrev);
                    });
                },

                toggleSection: toggleSection,
                openDirectSelection: openDirectSelection,
                collapseDirectSelection: collapseDirectSelection,
                nextSection: nextSection,
                prevSection: prevSection,
                expandAllSection: expandAllSection,
                collapseAllSection: collapseAllSection,
                collapseCurrentSection: collapseCurrentSection,
                loadByHash: loadByHash
            };
        }


        return {
            create: function(module, passedOptions) {
                return new Expander($(module), lodash.assign({}, options, passedOptions));
            }
        };
    });
});
